import React from "react";

export const IconFile = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <g id="file" transform="translate(-6 -2)">
                <g
                    id="Path_350"
                    data-name="Path 350"
                    transform="translate(6 2)"
                    fill="rgba(255,255,255,0)"
                >
                    <path
                        d="M 15.10000038146973 15.10000038146973 L 0.8999999761581421 15.10000038146973 L 0.8999999761581421 0.8999999761581421 L 10.39792346954346 0.8999999761581421 L 12.68591403961182 3.110903739929199 L 15.10000038146973 5.472360610961914 L 15.10000038146973 15.10000038146973 Z"
                        stroke="none"
                    />
                    <path
                        d="M 1.800000190734863 1.800000190734863 L 1.800000190734863 14.19999980926514 L 14.19999980926514 14.19999980926514 L 14.19999980926514 5.850980758666992 L 12.0576639175415 3.755350112915039 L 10.03413772583008 1.800000190734863 L 1.800000190734863 1.800000190734863 M 0 0 L 10.76172065734863 0 L 13.3125 2.464839935302734 L 16 5.09375 L 16 16 L 0 16 L 0 0 Z"
                        stroke="none"
                        fill="currentColor"
                    />
                </g>
                <line
                    id="Line_51"
                    data-name="Line 51"
                    x2="7.5"
                    transform="translate(10 14)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <line
                    id="Line_55"
                    data-name="Line 55"
                    x2="7.5"
                    transform="translate(10 11)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <path
                    id="Path_441"
                    data-name="Path 441"
                    d="M34.195,22.064v4.771h5.469"
                    transform="translate(-18.425 -19)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                />
            </g>
        </svg>
    );
};
